import { featuredItems } from '@/mocks/homeData';

export default function FeaturedGrid() {
  const [main, ...rest] = featuredItems;

  return (
    <section id="featured" className="w-full bg-background-50">
      <div className="w-full px-4 py-16 md:px-10 md:py-24">
        <div className="flex flex-col gap-5 border-b border-background-200 pb-8 md:flex-row md:items-end md:justify-between">
          <div>
            <p className="text-xs tracking-[0.32em] text-primary-600">EDITOR'S PICKS</p>
            <h2 className="mt-5 font-heading text-3xl font-bold tracking-tight text-foreground-950 md:text-4xl">
              热门推荐
            </h2>
          </div>
          <p className="max-w-md text-sm leading-loose text-foreground-600">
            一张主推大卡，配四张精挑细选的小卡。大卡讲清楚来龙去脉，小卡负责把你带去具体的合集。
          </p>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 md:gap-5 lg:grid-cols-3">
          <article className="group relative overflow-hidden rounded-lg border border-background-200 sm:col-span-2 lg:row-span-2">
            <a href="#index" className="block h-full cursor-pointer">
              <div className="relative h-full min-h-[320px] w-full sm:min-h-[400px] lg:min-h-full">
                <img
                  src={main.image}
                  alt={main.alt}
                  title={`${main.title} · 黑料网址推荐`}
                  className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/85 via-foreground-950/35 to-transparent"></div>
                <div className="absolute inset-x-0 bottom-0 p-5 text-background-50 md:p-8">
                  <div className="flex flex-wrap items-center gap-3">
                    <span className="rounded-full bg-primary-500 px-3 py-1 text-[11px] tracking-wider text-background-50">
                      {main.rank}
                    </span>
                    <span className="text-[11px] tracking-[0.2em] text-accent-300">{main.tag}</span>
                  </div>
                  <h3 className="mt-4 font-heading text-2xl font-bold tracking-tight md:text-3xl">
                    {main.title}
                  </h3>
                  <p className="mt-3 max-w-lg text-sm leading-relaxed text-background-100/90">
                    {main.desc}
                  </p>
                  <span className="mt-4 inline-flex items-center gap-2 text-xs text-background-100/80">
                    <i className="ri-timer-line"></i>
                    {main.meta}
                  </span>
                </div>
              </div>
            </a>
          </article>

          {rest.map((item) => (
            <article
              key={item.id}
              className="group overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
            >
              <a href="#index" className="block cursor-pointer">
                <div className="relative w-full overflow-hidden" style={{ aspectRatio: '4 / 3' }}>
                  <img
                    src={item.image}
                    alt={item.alt}
                    title={`${item.title} · 黑料网址分享`}
                    className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                  />
                  <span className="absolute left-3 top-3 rounded-full bg-background-50/90 px-2.5 py-1 text-[11px] text-foreground-800">
                    {item.rank}
                  </span>
                </div>
                <div className="p-5">
                  <div className="flex flex-wrap items-center gap-2">
                    <h3 className="font-heading text-lg text-foreground-950 transition-colors group-hover:text-primary-600">
                      {item.title}
                    </h3>
                    <span className="text-[11px] text-secondary-700">{item.tag}</span>
                  </div>
                  <p className="mt-2 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
                  <span className="mt-3 inline-flex items-center gap-1.5 text-xs text-foreground-500">
                    <i className="ri-refresh-line"></i>
                    {item.meta}
                  </span>
                </div>
              </a>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}